
import { defineComponent, PropType } from 'vue'
import {
  VulnerabilityRemediationFixPath,
  VulnerabilityRemediationFixPathUpdate,
  VulnerabilityRemediationPatchRunPullRequestStatus,
  VulnerabilityRemediationPatchRunStatus
} from '~/types/types'
import { resolveNodes } from '~/utils/array'

export default defineComponent({
  name: 'RemediationSelector',
  props: {
    fixPaths: {
      type: Array as PropType<VulnerabilityRemediationFixPath[]>,
      required: true
    },
    selectedFixPathId: {
      type: Object as PropType<VulnerabilityRemediationFixPath['id'] | null>,
      default: null
    }
  },
  computed: {
    selectedFixPath(): VulnerabilityRemediationFixPath | null {
      return this.fixPaths.find((fixPath) => fixPath.id === this.selectedFixPathId) ?? null
    },
    overallRiskScore() {
      const packageUpdates = this.getPackageUpdates(this.selectedFixPath)
      if (!packageUpdates.length) return null
      return Math.max(...packageUpdates.map((update) => update.overallRiskScore))
    },
    pullRequestUrl() {
      return this.selectedFixPath?.latestRemediationPatchRun?.vcsPrUrl ?? ''
    },
    commitUrl() {
      return this.selectedFixPath?.latestRemediationPatchRun?.vcsCommitUrl ?? ''
    },
    isPrViewable() {
      return Boolean(
        this.selectedFixPath?.latestRemediationPatchRun &&
          [
            VulnerabilityRemediationPatchRunPullRequestStatus.Pro,
            VulnerabilityRemediationPatchRunPullRequestStatus.Prm
          ].includes(this.selectedFixPath?.latestRemediationPatchRun.pullRequestStatus)
      )
    },
    isPrInProgress() {
      return (
        this.selectedFixPath?.latestRemediationPatchRun?.pullRequestStatus ===
        VulnerabilityRemediationPatchRunPullRequestStatus.Prp
      )
    },
    isRemediationRunRunning() {
      return (
        this.selectedFixPath?.latestRemediationPatchRun?.status ===
        VulnerabilityRemediationPatchRunStatus.Pend
      )
    }
  },
  emits: ['select-remediation', 'create-remediation'],
  methods: {
    getPackageUpdates(
      fixPath: VulnerabilityRemediationFixPath | null
    ): VulnerabilityRemediationFixPathUpdate[] {
      if (!fixPath) return []
      return resolveNodes(fixPath.packageUpdates)
    }
  }
})
